import { FC } from "react";
import { Icon, IconName } from "Components/UI/Icon";
import { GetAvatar, ThumbType } from "Utils/generateThumbnail";
import { BGColor, Container, Text, TextImg } from "./styles";
import "./styles.css";

interface IOptionImg {
  label: string;
  src?: string;
  thumbSrc?: string;
  thumbType?: ThumbType;
  avatar?: boolean;
  icon?: IconName;
  customColor?: string;
  customSize?: number;
  bgColor?: string;
  textColor?: string;
  marginRight?: string;
  containerMarginRight?: string;
}

const OptionCustom: FC<IOptionImg> = ({
  label,
  src,
  thumbSrc,
  thumbType,
  avatar,
  icon,
  customColor,
  customSize,
  bgColor,
  textColor,
  marginRight,
  containerMarginRight,
}) => {
  if (avatar) {
    return (
      <Container containerMarginRight={containerMarginRight}>
        <span style={{ marginRight: marginRight || '8px' }}>
          <GetAvatar
            name={label}
            shape='circle'
            size={18}
            fontSize={12}
            src={src}
            thumbSrc={thumbSrc}
            thumbType={thumbType}
          />
        </span>
        <TextImg>{label}</TextImg>
      </Container>
    );
  }
  if (icon && bgColor) {
    return (
      <Container containerMarginRight={containerMarginRight}>
        <BGColor bgColor={bgColor}>
          <span>
            <Icon
              icon={icon}
              customSize={customSize ? customSize : 14}
              customColor={customColor}
              style={{ marginRight: marginRight || '8px' }}
            />
          </span>
          <TextImg textColor={textColor}>
            {label}
          </TextImg>
        </BGColor>
      </Container>
    );
  }
  if (bgColor) {
    return (
      <Container containerMarginRight={containerMarginRight}>
        <BGColor bgColor={bgColor}>
          <TextImg textColor={textColor}>
            {label}
          </TextImg>
        </BGColor>
      </Container>
    );
  }
  if (icon) {
    return (
      <Container containerMarginRight={containerMarginRight}>
        <span>
          <Icon
            icon={icon}
            customSize={customSize ? customSize : 14}
            customColor={customColor}
            style={{ marginRight: marginRight || '8px' }}
          />
        </span>
        <TextImg textColor={textColor}>
          {label}
        </TextImg>
      </Container>
    );
  }
  return (
    <Container containerMarginRight={containerMarginRight}>
      <Text>{label}</Text>
    </Container>
  );
}

export default OptionCustom;
